export const UserActionTypes = {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",
  USER_LOADED: "USER_LOADED",
  LOGOUT: "LOGOUT",
  LOGOUT_FAIL: "LOGOUT_FAIL",
  LOGIN_NOT_CONFIRMED: "LOGIN_NOT_CONFIRMED",
  AUTH_ERROR: "AUTH_ERROR",
};
